import { FC } from 'react';

import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import { useFormat } from '../../../../hooks/index';
import { eventFormType, EventTypeBackend } from '../../../../types/events.types';
import { CardProps } from './transaction-card-variants.types';
import { TransactionOverviewItem } from './transaction-overview-item';
import { TransactionTitleItem } from './transaction-title-item';

export const Expire: FC<CardProps> = ({ event }) => {
  const { format } = useFormat();

  if (event.type !== EventTypeBackend.EXPIRE) return <></>;

  const {
    type,
    exercise: { items },
    createdAt,
  } = event;

  return (
    <>
      {items.map(({ id, vestingTask, exercised }) => (
        <div className="flex flex-col divide-y divide-gray-100 rounded-md shadow-sm" key={id}>
          <TransactionTitleItem
            createdAt={format(createdAt, 'dd/MM/yyyy')}
            name={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="TRANSACTION_TYPE" />}
            value={<AppFormattedMessage id={eventFormType[type]} />}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="STAKEHOLDER" />}
            value={vestingTask.grantItem.stakeholder.fullName}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="EXPIRED_WARRANTS" />}
            value={exercised.toLocaleString('en-US')}
          />
          <TransactionOverviewItem
            title={<AppFormattedMessage id="SHARE_CLASS" />}
            value={vestingTask.grantItem.plan.pool.shareClass.name}
          />
        </div>
      ))}
    </>
  );
};
